import React from 'react';

interface CalendarIconProps {
  color?: string;
  className?: string;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({
  color = '#3B82F6',
  className = '',
}) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <rect
        x='3'
        y='4'
        width='18'
        height='18'
        rx='2'
        ry='2'
        fill='none'
        stroke={color}
        strokeWidth='2'
      />
      <line x1='16' y1='2' x2='16' y2='6' stroke={color} strokeWidth='2' />
      <line x1='8' y1='2' x2='8' y2='6' stroke={color} strokeWidth='2' />
      <line x1='3' y1='10' x2='21' y2='10' stroke={color} strokeWidth='2' />
    </svg>
  );
};
